<template>
    <div class="inline-background">
        <svg
            :width="width"
            height="35"
            :viewBox="`0 0 ${width} 33`"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_198_2343)">
                <g clip-path="url(#clip0_198_2343)">
                    <rect
                        x="4"
                        y="2"
                        width="69"
                        height="27"
                        rx="12"
                        :fill="colorBase"
                    />
                    <ellipse
                        cx="64"
                        cy="34"
                        rx="60"
                        ry="40"
                        fill="url(#paint0_linear_198_2343)"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_d_198_2343"
                    x="0"
                    y="0"
                    :width="width"
                    height="32"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 0.776471 0 0 0 0 0 0 0 0 0 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_198_2343"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_198_2343"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_198_2343"
                    x1="84.5"
                    y1="50"
                    x2="8.5"
                    y2="-2.50001"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop :stop-color="colorOutline" />
                    <stop offset="1" :stop-color="colorInline" />
                </linearGradient>
                <clipPath id="clip0_198_2343">
                    <rect
                        x="4"
                        y="2"
                        :width="width-5"
                        height="24"
                        rx="12"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
        <div class="text-tier-inline text-over w-80">
            <img
                class="mr-2 tier-logo"
                :src="image"
                width="20"
                height="20"
                alt="point icon"
            />
            <span class="tier-text text-over">{{ tierName }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BackgroundTier',
    props: {
        width: {
            type: Number,
            default: () => 85
        },
        colorBase: {
            type: String,
            default: () => '#28A1F9'
        },
        colorOutline: {
            type: String,
            default: () => '#25DAFF'
        },
        colorInline: {
            type: String,
            default: () => '#0078E7'
        },
        image: {
            type: String,
            default: () => 'https://images.foodstory.co/membership-tier/icon-1.svg'
        },
        tierName: {
            type: String,
            default: () => 'Member'
        }
    }
}
</script>

<style lang="css" scoped>
.inline-background {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.text-tier-inline {
    position: absolute;
    display: flex;
    align-items: flex-end;
    top: 5px;
}

.tier-logo {
    filter: invert(100%) sepia(0%) saturate(7428%) hue-rotate(2deg) brightness(96%) contrast(98%);
}

.tier-text {
    color: #fff;
    font-weight: 500;
    font-size: 16px;
}

.w-80 {
    width: 80%;
}
</style>
